import React from 'react';
import { ActionListUserProps } from './types';
import { UserInfo, UserWrapper } from './action-list-user.styles';
import { Button } from '@vtbhome/juicyfront';
import { AllAdd, AllTrash } from '@vtbhome/juicyfront/indexIcon';
import { Photo } from '@shared/ui/photo/photo';
import { Typography } from '@shared/ui/typography/typography';

export const ActionListUser: React.FC<ActionListUserProps> = ({
    action = 'add',
    name,
    photoUrl,
    jobTitle,
    onAction,
}) => (
    <UserWrapper>
        <Photo size='l' photoUrl={photoUrl} name={name} />
        <UserInfo>
            <Typography size='body1_short'>{name}</Typography>
            <Typography size='body1_short' color='neutral_50'>
                {jobTitle}
            </Typography>
        </UserInfo>
        <Button
            buttonType='secondary'
            size='s'
            startAdornment={action === 'add' ? <AllAdd size='xxs' /> : <AllTrash size='xxs' />}
            onClick={onAction}
        />
    </UserWrapper>
);
